import {is_function} from "./types";

/**
 * Indexes entries of an array by {key} and returns result
 *
 * @template T
 * @param {T[]} arr The array to index
 * @param {keyof T|((val: T) => string|number)} key Key to use to index items, can be either a property name or callback which returns a key
 * @return {Record<keyof T, T>}
 */
export function indexBy(arr, key) {
    if (!is_function(key)) {
        key = (item) => item[key];
    }

    return arr.reduce((result, item) => {
        return {
            ...result,
            [key(item)]: item,
        };
    }, {});
}



/**
 * Returns all items of array that are also present in other
 * @param {array} other
 * @return {array}
 */
Array.prototype.intersect = function(other) {
    return this.filter(item => other.includes(item));
};

/**
 * Returns all items of array that are not present in {other}
 * @param {array} other
 * @return {array}
 */
Array.prototype.diff = function(other) {
    return this.filter(item => !other.includes(item));
};


export function array_intersect(a, b) {
    return a.intersect(b);
}

export function array_diff(a, b) {
    return a.diff(b);
}
